import { Pipe, PipeTransform } from '@angular/core';
import { minutesToMHDConvert } from '../../helpers';

@Pipe({
    name: 'minutesToMHD',
    standalone: false
})
export class MinutesToMHDPipe implements PipeTransform {
    transform(value: number): string {
        return minutesToMHDConvert(value);
        
    }
}
